// Chakra UI
import Main from "./components/main";

function App() {
  return <Main />;
}

export default App;
